import '../../js/base';

import '../../js/qna';

import initEmailAlertForm from '../../js/partials/_email-alert-form';

initEmailAlertForm();
